// ============================================================================
// page-service-single / hero.js
// ----------------------------------------------------------------------------
// Hero SCROLL button: smooth-scrolls to the first content section.
//
// The original inline JS used the Oxygen-generated id `#_dynamic_list-293-3034`
// directly. We keep that as the primary target (matches current behaviour)
// and fall back to the first `.service-content` section if the id ever
// changes — so this keeps working through Oxygen rebuilds.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const scrollButton = document.querySelector(".service-hero__scroll");
  const target =
    document.querySelector("#_dynamic_list-293-3034") ||
    document.querySelector(".service-content");

  if (!scrollButton || !target) return;

  scrollButton.addEventListener("click", function () {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});
